import {SiePedidosBaseAPI} from "@/api/sie-pedidos.base.api";
import {
  VUE_APP_SIE_PEDIDOS_API_URL
} from "@/commons/config";
import {AxiosObservable} from "axios-observable/dist/axios-observable.interface";
import {DadosAluno} from "@/models/sie-pedidos/dadosAluno";
import {DadosParaSolicitacao} from "@/models/sie-pedidos/dadosParaSolicitacao";
import SiePedidosAuthService from "@/services/sie-pedidos/auth.service";

export class SolicitacaoApi extends SiePedidosBaseAPI<DadosAluno> {
  constructor() {
    super();
    this.apiUrl = VUE_APP_SIE_PEDIDOS_API_URL;
  }
  public getDocumentos(cpf: string): AxiosObservable<DadosAluno> {
    return this.axios.post(`${this.apiUrl}/getDocumentos`, { cpf });
  }
  public getStatusSolicitacao(cpf: string, tipoSolicitacaoId: number){
    return this.axios.get(`${this.apiUrl}/central-servicos/entidades/solicitacoes/aluno`, {params: {cpf, tipoSolicitacaoId}});
  }
  public getStatusAlunoSolicitacao(dados: object){
    return this.axios.get(`${this.apiUrl}/central-servicos/alunos/solicitacoes`, {params: dados})
  }
  public gerarSolicitacao(formData: FormData): AxiosObservable<any>{
    const token = SiePedidosAuthService.token;
    return this.axios.post(`${this.apiUrl}/central-servicos/entidades/solicitacoes`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      }});
  }
  public getDadosParaSolicitacao(): AxiosObservable<DadosParaSolicitacao> {
    return this.axios.get(`${this.apiUrl}/central-servicos/entidades/solicitacoes/setup-create`);
  }
  public getDadosEndereco(cep: string): AxiosObservable<DadosAluno>{
    return this.axios.get(`${this.apiUrl}/ceps/${cep}`);
  }
  public segundaVia(cpf: string): AxiosObservable<any>{
    return this.axios.get(`${this.apiUrl}/central-servicos/entidades/solicitacoes/2via/${cpf}`);
  }
}
